import httpClient from "../http/http-client";
import { IPostSubsidiary, ISubsidiary } from './subsidiary.model';

export default class SubsidiaryService {
  http;
  subsidiaries?: ISubsidiary[];
  static instance = new SubsidiaryService();

  static getInstance() {
    if (SubsidiaryService.instance === null) SubsidiaryService.instance = new SubsidiaryService();
    return this.instance;
  }

  constructor() {
    this.http = httpClient
  }

  async getAll(forceUpdate: boolean = false): Promise<ISubsidiary[]> {
    if (this.subsidiaries && !forceUpdate) {
      return Promise.resolve(this.subsidiaries);
    }
    return this.http.get('subsidiary')
      .then(response => {
        this.subsidiaries = response.data.rows;
        return response.data.rows
      })
      .catch(err => {
        throw err
      });
  }

  async getAllSubsidiariesWithPagination(active: boolean | undefined, searchQuery: string, page: number, perPage: number = 10, orderBy?: string, order?: 'asc' | 'desc'): Promise<{ count: number, rows: ISubsidiary[] }> {
    const activeParam = active === undefined ? '' : `&active=${active}`
    return this.http.get(`subsidiary?${activeParam}&nameIncludes=${searchQuery}&page=${page}&perPage=${perPage}${order && orderBy ? `&orderBy=${orderBy}&order=${order}` : ''}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        throw err;
      });
  }

  async getOne(subsidiaryId: string): Promise<ISubsidiary> {
    return this.http.get(`subsidiary/${subsidiaryId}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async create(subsidiary: IPostSubsidiary): Promise<ISubsidiary> {
    return this.http.post('subsidiary', subsidiary)
      .then(response => {
        return response.data
      })
      .catch(err => {
        throw err
      });
  }

  async update(subsidiaryId: string, subsidiary: IPostSubsidiary ): Promise<ISubsidiary> {
    return this.http.patch(`subsidiary/${subsidiaryId}/update`, subsidiary)
      .then(response => {
        return response.data
      })
      .catch(err => {
        throw err
      });
  }

  async deactivate(subsidiaryId: string): Promise<ISubsidiary> {
    return this.http.patch(`subsidiary/${subsidiaryId}/deactivate`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        throw err
      });
  }

  async reactivate(subsidiaryId: string): Promise<ISubsidiary> {
    return this.http.patch(`subsidiary/${subsidiaryId}/reactivate`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        throw err
      });
  }

  async remove(subsidiaryId: string): Promise<{ message: string }> {
    return this.http.delete(`subsidiary/${subsidiaryId}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        throw err
      });
  }

  clearData() {
    this.subsidiaries = undefined;
  }

}